import $ from 'jquery';
import DateFilter from '@/components/date-filter';
import api_op from "@/api/comptabilite/_operations"

export default {
    name: 'facture-en-cours',
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            fields: [
                'patient', { key: 'montant_du', label: 'Montant dû' }
            ],
            filter: "",
            perPage: 50,
            currentPage: 1,
            selected_patient: {
                patient_id: '',
                nom_patient: '',
                sexe: '',
                telephone_mobile: '',
                age: ''
            },
            operations_en_attente: [],
            operations_length: 0,
            is_month: false,
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                
                if (this.filter_by_date.slug) {
                    $('.date-filter-cfactures').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
            }
            this.is_month = true
            this.current_date_filter = data
            this.getListeOperations(data)
        },
    },

    computed: {

    },

    mounted() {
        console.log("Load op en attente");
        
        this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", {});

        const data = {
            month: this.curr_month.id,
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.getListeOperations(data)
    },

    methods: {
        /**
         * Liste des opération en attente
         * @param {*} data 
         * @returns 
         */
        getOpertaionsEnAttente(data) {
            return new Promise((resolve, reject) => {
                api_op.getOpertaionsEnAttente(data).then(
                    (response) => {
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },

        getListeOperations(data) {
            this.is_load_error = false
            this.is_loading = true
            this.getOpertaionsEnAttente(data).then((response) => {
                this.operations_en_attente = response
                this.operations_length = response.length
                if (this.operations_en_attente.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }

            this.filter_date = ""
            this.is_month = false
            this.current_date_filter = data
            this.getListeOperations(data)
        },

        /**
         * Actualiser la facturation en cours
         */
        refreshFacture() {
            console.log("refresh op");
            
            this.getListeOperations(this.current_date_filter)
        },

        goToFactureAttente(info_patient, patient_id) {
            this.selected_patient = {
                patient_id: patient_id,
                nom_patient: info_patient.patient,
                nom: info_patient.patient,
                prenoms: "",
                sexe: info_patient.sexe,
                telephone_mobile: info_patient.telephone,
                age: info_patient.age,
                num_dossier: info_patient.num_dossier
            }
            this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", this.selected_patient);

            this.$router.push({ path: '/factures/patients-operations' })
        },
    }
}